import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseButtonGrey = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 16,
		cy: 16,
		r: 16,
		fill: "#D2DCE2"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17.9811 16L22.3217 11.6594C22.4259 11.5552 22.4259 11.3863 22.3217 11.2821L20.7181 9.67816C20.6681 9.62813 20.6 9.59998 20.5295 9.59998C20.4587 9.59998 20.3908 9.62813 20.3408 9.67816L16 14.0189L11.6591 9.67816C11.5591 9.5781 11.3819 9.5781 11.2818 9.67816L9.67813 11.2821C9.57393 11.3863 9.57393 11.5552 9.67813 11.6594L14.0188 16L9.67813 20.3407C9.57393 20.4449 9.57393 20.6138 9.67813 20.718L11.2818 22.3218C11.3319 22.3718 11.3998 22.4 11.4705 22.4C11.5412 22.4 11.6091 22.3718 11.6591 22.3218L16 17.981L20.3408 22.3218C20.3908 22.3718 20.4587 22.4 20.5295 22.4C20.6 22.4 20.6681 22.3718 20.7181 22.3218L22.3218 20.718C22.426 20.6138 22.426 20.4447 22.3218 20.3407L17.9811 16Z",
		fill: "#617985"
	})]
});
export default SvgCloseButtonGrey;
